import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { theme } from "@miro-site/design-tokens";
export var resetStyles = {
    transition: "color ".concat(theme.animation.transitionDuration, ", borderColor ").concat(theme.animation.transitionDuration),
    display: "inline-block",
    border: "none",
    textDecoration: "none",
    cursor: "pointer"
};
var dsFocusStyles = _object_spread({}, theme.focus.outlines.withOffset);
var defaultLink = {
    borderBottom: "1px solid currentColor",
    transition: "border-color ".concat(theme.animation.transitionDuration),
    "&:hover": {
        borderColor: "transparent"
    }
};
var linkWithArrow = {
    "&:hover": {
        ".link-text": {
            borderColor: "transparent"
        }
    },
    ".link-text": {
        display: "inline",
        borderBottom: "1px solid currentColor",
        transition: "border-color ".concat(theme.animation.transitionDuration)
    },
    ".link-arrow": {
        marginLeft: 5
    }
};
export var arrowLinkVariants = {
    default: _object_spread_props(_object_spread({}, linkWithArrow), {
        fontWeight: 500,
        "&:focus": _object_spread({}, theme.focus.outlines.withOffset)
    }),
    regular: _object_spread_props(_object_spread({}, linkWithArrow), {
        fontWeight: 400,
        "&:focus": _object_spread({}, theme.focus.outlines.withOffset)
    }),
    richText: _object_spread_props(_object_spread({
        display: "inline",
        fontWeight: 400,
        border: "1px solid transparent"
    }, linkWithArrow), {
        "&:focus": _object_spread({}, theme.focus.outlines.default)
    }),
    dsDefault: _object_spread_props(_object_spread({}, linkWithArrow), {
        ".link-text": _object_spread_props(_object_spread({}, linkWithArrow[".link-text"]), {
            borderBottom: "none"
        }),
        color: "var(--colors-font-default-idle)",
        "&:hover": {
            color: "var(--colors-font-default-hover)"
        },
        "&:active": {
            color: "var(--colors-font-default-active)"
        },
        "&:focus": _object_spread({}, dsFocusStyles)
    }),
    dsNeutral: _object_spread_props(_object_spread({}, linkWithArrow), {
        ".link-text": {
            borderBottom: "none"
        },
        color: "var(--colors-font-primary)",
        "&:hover": {
            color: "var(--colors-font-default-hover)"
        },
        "&:active": {
            color: "var(--colors-font-default-active)"
        },
        "&:focus": _object_spread({}, dsFocusStyles)
    })
};
export var variants = {
    default: _object_spread_props(_object_spread({}, defaultLink), {
        fontWeight: 500,
        "&:focus": _object_spread({}, theme.focus.outlines.withOffset)
    }),
    regular: _object_spread_props(_object_spread({}, defaultLink), {
        fontWeight: 400,
        "&:focus": _object_spread({}, theme.focus.outlines.withOffset)
    }),
    richText: _object_spread_props(_object_spread({
        display: "inline",
        fontWeight: 400,
        border: "1px solid transparent"
    }, defaultLink), {
        "&:focus": _object_spread({}, theme.focus.outlines.default)
    }),
    dsDefault: {
        color: "var(--colors-font-default-idle)",
        "&:hover": {
            color: "var(--colors-font-default-hover)"
        },
        "&:active": {
            color: "var(--colors-font-default-active)"
        },
        "&:focus": _object_spread({}, dsFocusStyles)
    },
    dsNeutral: {
        ".link-text": {
            borderBottom: "none"
        },
        color: "var(--colors-font-primary)",
        "&:hover": {
            color: "var(--colors-font-default-hover)"
        },
        "&:active": {
            color: "var(--colors-font-default-active)"
        },
        "&:focus": _object_spread({}, dsFocusStyles)
    }
};
export var sizes = {
    dsBodyText1: {
        fontFamily: "Formular",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "var(--font-sizes-225)",
        lineHeight: "135%",
        ".link-arrow::after": {
            marginLeft: "var(--space-offset-50)",
            fontSize: "var(--font-sizes-300)",
            position: "relative"
        },
        ".focus-trap": {
            display: "flex",
            alignItems: "center"
        }
    },
    dsBodyText2: {
        fontFamily: "Formular",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "var(--sizes-font-175)",
        lineHeight: "115%",
        ".link-arrow::after": {
            marginLeft: "var(--space-offset-50)",
            fontSize: "var(--font-sizes-300)",
            position: "relative"
        },
        ".focus-trap": {
            display: "flex",
            alignItems: "center"
        }
    },
    small: {
        fontSize: 14,
        lineHeight: 20
    },
    default: {
        fontSize: 18,
        lineHeight: 24
    },
    medium: {
        fontSize: 16,
        lineHeight: 24
    },
    large: {
        fontSize: 24,
        lineHeight: 32
    }
};
export var colors = {
    indigo: {
        color: theme.colors.primaryIndigo
    },
    default: {
        color: theme.colors.primaryBlue,
        "&:hover": {
            color: theme.colors.primaryBlueHover
        }
    },
    white: {
        color: theme.colors.primaryWhite,
        "&:hover": {
            color: theme.colors.outspoken
        }
    },
    pink: {
        color: theme.colors.human
    },
    yellow: {
        color: theme.colors.outspoken
    }
};
export default {
    resetStyles: resetStyles,
    sizes: sizes,
    colors: colors,
    variants: variants,
    arrowLinkVariants: arrowLinkVariants
};
